import React from 'react'

import { DesktopOnly, Responsive } from 'ui/acro'

import { stories } from '../_media'

import CenteredInfoSection from '../CenteredInfoSection'
import StoriesCarousel from './StoriesCarousel'
import StoriesResponsive from './StoriesResponsive'

const Stories = ({ ...rest }) => {
  return (
    <React.Fragment>
      <CenteredInfoSection
        headline='On the Blog'
        body='Weekly inspiration for mindful living. Discover yoga sequences, short workouts, recipes, and mindfulness tips from the experts.'
        {...rest}
      />
      <DesktopOnly mt={['46px', '44px']}>
        <StoriesResponsive stories={stories} />
      </DesktopOnly>

      <Responsive
        show={[true, true, false]}
        display='block'
        mt={['46px', '44px']}
        maxWidth='100vw'
      >
        <StoriesCarousel stories={stories} />
      </Responsive>
    </React.Fragment>
  )
}

Stories.propTypes = {}

export default Stories
